import { useMutation, useQueryClient, type QueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import { clavesSatAdminKey } from "./use-claves-sat-admin";
import { crearClaveSat, editarClaveSat, type CrearClaveSatInput } from "../services/claves-sat-admin-service";

/** Invalida el listado paginado del admin Y el catálogo completo del picker. */
function invalidar(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: clavesSatAdminKey });
  void qc.invalidateQueries({ queryKey: qk.clavesSat });
}

export function useCrearClaveSat(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearClaveSatInput) => crearClaveSat(input),
    onSuccess: () => {
      toastExito({ title: "Clave SAT creada", message: "Disponible en el catálogo." });
      invalidar(qc);
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEditarClaveSat(opts?: { onEditado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ clave, descripcion }: { clave: string; descripcion: string }) => editarClaveSat(clave, descripcion),
    onSuccess: () => {
      toastExito({ title: "Descripción actualizada", message: "Cambios guardados." });
      invalidar(qc);
      opts?.onEditado?.();
    },
    onError: toastErrorApi,
  });
}
